export const capitalizeText = (text) => {
    if (!text)
        return '';
    return text
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
export const formatFullName = (firstName, lastName) => {
    return `${firstName.trim()} ${lastName.trim()}`;
};
